// ROC曲线图
import ChartTemplate from '../ChartTemplate';
export default {
  extends: ChartTemplate,
  props: {
    width: { default: '400px' },
    height: { default: '400px' },
    config: {
      default: function () { return { group: 0, name: -1, x: 1, y: 2, order: 1 } }
    }
  },
  data () {
    return { diagonalLine: true }
  },
  methods: {
    initParamAfter () {
      this.diagonalLine = this.paramFormData.diagonalLine;
    },
    initChartAfter () {
      this.drawDiagonalLine();
    },
    onParamFormChangedBefore (e, item) {
      if (item.code == 'diagonalLine_roc') this.diagonalLine = e;
    },
    onParamFormChangedAfter () {
      this.drawDiagonalLine();
    },
    // ======================= 绘制对角线
    drawDiagonalLine () {
      let $diagonalLine = document.getElementById(`${this.chartElId}_diagonal_line`);
      if ($diagonalLine) $diagonalLine.remove();
      let x1 = this.chart.xAxis[0].toPixels(-0.05), x2 = this.chart.xAxis[0].toPixels(1.05), y1 = this.chart.yAxis[0].toPixels(-0.05), y2 = this.chart.yAxis[0].toPixels(1.05);
      let points = ['M', x1, y1, 'L', x2, y2];
      let diagonalLine = this.chart.renderer.path(points).attr({ id: `${this.chartElId}_diagonal_line`, stroke: '#00000033', 'stroke-width': 1 }).add();
      if (this.diagonalLine == false) diagonalLine.hide();
    },
  }
}